<div class="sb-step sb-step-contacts">
  <form class="sb-step__form" [formGroup]="formGroup">
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <!-- <sb-promo-banner></sb-promo-banner> -->
        <div class="sb-form-block" formGroupName="customerContacts" style="margin-bottom: 30px;">
          <div class="sb-form-block__title">
            <div class="row">
              <div class="col-xs-12">
                {{'ENTITY.CONTACTS.TITLE' | translate}}
              </div>
            </div>
          </div>
          <div class="sb-form-block__fields">
            <div class="row wt-margin-bottom-4">
              <div class="col-tb-6 col-xs-12">
                <wt-input-text [validateOnBlur]="true" [maxLength]="FormConstants.MAXIMUM_EMAIL_LENGTH" additionalClass="sb-transform-lowercase" [label]="'ENTITY.CONTACTS.EMAIL' | translate" formControlName="email"></wt-input-text>
              </div>
              <div class="col-tb-6 col-xs-12">
                <wt-input-text [validateOnBlur]="true" [disablePaste]="true" [maxLength]="FormConstants.MAXIMUM_EMAIL_LENGTH" additionalClass="sb-transform-lowercase" [label]="'ENTITY.CONTACTS.CONFIRM_EMAIL' | translate" formControlName="confirmEmail"></wt-input-text>
              </div>
              <ng-container *ngIf="simType === SIM_TYPES.eSim">
                <div class="col-xs-12 wt-margin-bottom-10">
                  <sb-box-info [iconType]="['icon-mix-qrcode-green']" [infoText]="'ENTITY.SIM-TYPE.CONTACTS' | translate"></sb-box-info>
                </div>
              </ng-container>
              <div class="col-tb-6 col-xs-12">
                <wt-input-text [validateOnBlur]="true" [maxLength]="FormConstants.MAXIMUM_MOBILE_NUMBER_LENGTH" [label]="'ENTITY.CONTACTS.MOBILE' | translate" type="tel" formControlName="mobileNumber"></wt-input-text>
              </div>
              <div class="col-xs-12 col-xs-12">
                <sb-box-info [iconType]="['icon-alert-info-green']" [infoText]="(simType === SIM_TYPES.eSim ? 'ENTITY.CONTACTS.INFO_ESIM' : 'ENTITY.CONTACTS.INFO') | translate"></sb-box-info>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="simType === SIM_TYPES.IdleSim">
          <!-- region General Consents -->
          <div class="sb-form-block__fields" formGroupName="generalConsents">
            <div class="row wt-margin-bottom-4">
              <div class="col-xs-12 flex">
                <wt-input-checkbox formControlName="generalServiceConditionsAccepted">
                  <div class="wt-text-light-m" [innerHTML]="'ENTITY.CONSENTS.UNIQUE-CONSENTS' | translate:{ precontractUrl: precontractUrl }"></div>
                </wt-input-checkbox>
                <wt-info-note [showCloseButton]="true" [invert]="true" width="615px" class="flex__info-note" text="{{'ENTITY.CONSENTS.GENERAL-CONSENTS.TOOLTIP-TEXT' | translate}}"></wt-info-note>
              </div>
            </div>
            <!-- <div class="row" *ngIf="precontractUrl">
              <div class="col-xs-12 flex">
                <wt-input-checkbox formControlName="precontractConditionsAccepted">
                  <div class="wt-text-light-m" [innerHTML]="'ENTITY.CONSENTS.PRE-CONTRACT' | translate:{ precontractUrl: precontractUrl }"></div>
                </wt-input-checkbox>
              </div>
            </div> -->
            <div class="row">
              <div class="col-xs-12 flex">
                <div class="wt-text-light-m wt-margin-top-4 sb-color-grey-dark" [innerHTML]="'ENTITY.CONSENTS.GDPR' | translate"></div>
              </div>
            </div>
          </div>
          <!-- endregion -->
        </ng-container>
      </div>
    </div>

    <div class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="formGroupInvalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </div>
  </form>
</div>

